module.exports = __webpack_public_path__ + "img/doe-logo.ae8ca0d7.jpeg";